import React from 'react';
import {Image, Title, Slideshow} from './../../Basics';
import Particle from './../../Particle'; //eslint-disable-line no-unused-vars

const Particle15 = () => (<div>

  <Title>Obstacles in the exoskeleton race</Title>
  <Slideshow>

    <section>
      <Image
        source={require('./15_Bild_1_Schiefe_Ebene_EXO_Team_VariLeg_AlessandroDellaBella_065.jpg')}
        title='---'
        caption='The exoskeleton course involved moving over sloping surfaces…'
      />
    </section>

    <section>
      <Image
        source={require('./15_Bild_2_Inseln_EXO_Team_SG-Mechatronics_AlessandroDellaBella_060.jpg')}
        title='---'
        caption='…or placing ones feet only on the grey stones while walking. These tasks were intended
        to simulate conditions present for example on unpaved forest paths.'
      />
    </section>
    <section>
      <Image
        source={require('./15_Bild_3_Sofa_EXO_Team_PolyWalk-EPFL_NicolaPitaro_6941.jpg')}
        title='---'
        caption='Even with an exoskeleton, rising from a chair is a big challenge for someone whose legs are paralysed.'
      />
    </section>

    <section>
      <Image
        source={require('./15_Bild_4_EXO_Team.jpg')}
        title='---'
        caption='The competitors were also asked to negotiate stairs. Fotos: ETHZ'
      />
    </section>


</Slideshow>

  <Particle
  number={14}
  />

  <Particle
  number={17}
  />

</div>);

export default Particle15;



/** WEBPACK FOOTER **
 ** ./src/Particles/Particle15/Particle15_EN.js
 **/